import { render, staticRenderFns } from "./EditUserDialog.vue?vue&type=template&id=6477d012&scoped=true"
import script from "./EditUserDialog.vue?vue&type=script&lang=js"
export * from "./EditUserDialog.vue?vue&type=script&lang=js"
import style0 from "./EditUserDialog.vue?vue&type=style&index=0&id=6477d012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6477d012",
  null
  
)

export default component.exports